import { render, staticRenderFns } from "./paytest.vue?vue&type=template&id=b871edb4&scoped=true"
import script from "./paytest.vue?vue&type=script&lang=js"
export * from "./paytest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b871edb4",
  null
  
)

export default component.exports